// The second attribution mechanism, browser half (doc/product-analytics.md §5, A4): copy PostHog's
// distinct_id into the signup form's hidden field, so the server can alias the account it is about
// to create onto the browsing session that produced it.
//
// Pure, like posthog_pageviews.js: it imports nothing and touches no globals, so `node --test`
// (packs/assets/spec/javascript/analytics/posthog_attribution.test.js) can pin the one rule that
// actually matters here, which is when NOT to fill the field.
//
// The signup form renders this hidden input (packs/marketing/app/views/marketing/shared/
// _signup_form.html.erb). Every other page simply has none, and filling zero fields is the
// ordinary case rather than an error.
export const DISTINCT_ID_FIELD_SELECTOR = "[data-post-hog-distinct-id-field]"

// What posthog-js sends as the distinct_id under cookieless_mode, in place of a real one: the
// actual id is derived server-side, rotates daily, and is never visible to this page. Writing this
// string into the form would look like attribution and join to nothing.
export const COOKIELESS_SENTINEL = "$posthog_cookieless"

// Consent is the whole gate, and checking it is not the same as checking that an id exists.
// posthog-js is initialised with opt_out_capturing_by_default, so a visitor who has not chosen is
// in the rejected-by-default cohort: captured cookielessly, with no durable id to link and no
// permission to link one. Only an explicit opt-in produces an id that means anything here, and
// everyone else degrades to null, which the form posts as an empty string and the server stores as
// nil.
export function attributableDistinctId({ distinctId, optedIn }) {
  if (!optedIn) return null
  if (!distinctId || distinctId === COOKIELESS_SENTINEL) return null

  return distinctId
}

export function fillDistinctIdFields({ documentRoot, distinctId, optedIn }) {
  const attributable = attributableDistinctId({ distinctId, optedIn })
  if (!attributable) return

  documentRoot.querySelectorAll(DISTINCT_ID_FIELD_SELECTOR).forEach((field) => {
    field.value = attributable
  })
}
